import React from 'react'
import { connect } from 'react-redux'
import { addQuestionImage, addChoiceImage } from '../../prosemirror/utils/editorActions/addImage'
import EditorInsertImageModal from '../../components/richEditor/editorUI/modals/EditorInsertImageModal'
import { imageSearch } from '../../actions/imageSearch'
import { showNotification } from '../../actions/notifications'
import analytics from '../../utils/cdpAnalytics'

const MAX_FILE_SIZE = 20000000

class EditorInsertImageModalContainer extends React.Component {
  constructor() {
    super()
    this.handleSelectImage = this.handleSelectImage.bind(this)
    this.handleNewImageSearch = this.handleNewImageSearch.bind(this)
    this.handleLoadMore = this.handleLoadMore.bind(this)
    this.handleSelectFile = this.handleSelectFile.bind(this)
    this.handleImageSearchBarPaste = this.handleImageSearchBarPaste.bind(this)
    this.clearSearch = this.clearSearch.bind(this)

    this.state = ({
      submitLoading: false,
      images: [],
      searchTerm: '',
      isSearching: false,
      noResults: false,
      count: 50,
      offset: 0,
    })
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  handleKeyDown(e) {
    e.stopPropagation()
  }

  handleImageSearchBarPaste(event) {
    const {
      insertPos, isQuestion, questionPos, questionNode,
    } = this.props

    const { clipboardData } = event
    const html = event.clipboardData.getData('text/html')
    let src = null
    const thumbnail = null
    let file = null
    const { files } = clipboardData
    const pastedFile = files[0]
    if (pastedFile) {
      file = pastedFile
    } else if (html) {
      const regExp = '<img[^>]* src="([^"]*)"[^>]*>'
      const match = html.match(regExp)
      // check if has an image in it
      if (match && match[1]) { // handle google docs images
        src = match[1]
      }
    }

    if (file || src) {
      if (file && file.size > MAX_FILE_SIZE) {
        this.props.closeInsertImageModal()
        this.props.showNotification('The maximum file size you can upload is 20mb.', 'Sadly your image file is too large. ', 'destroy')
      } else {
        this.props.closeInsertImageModal()
        const title = ''
        const attribution = ''
        const isCopyPaste = true
        const isSearchBarPaste = true
        const isImageSearch = false
        if (isQuestion) {
          this.props.addQuestionImage(src, thumbnail, title, attribution, insertPos, questionPos, questionNode, file, isImageSearch, isCopyPaste, isSearchBarPaste)
        } else {
          this.props.addChoiceImage(src, thumbnail, title, attribution, insertPos, file, isImageSearch, isCopyPaste, isSearchBarPaste)
        }
      }
    }
  }

  clearSearch() {
    this.setState({
      isSearching: false,
      images: [],
      searchTerm: '',
      offset: 0,
      noResults: false,
    })
  }

  async handleNewImageSearch(searchTerm) {
    const { count } = this.state
    const { imageSearch } = this.props
    if (searchTerm) {
      analytics.track('Image search', {
        searchTerm,
      })

      this.setState({
        isSearching: true,
        noResults: false,
        images: [],
      })
      try {
        const {
          searchResults,
          resultCount,
          nextOffset,
        } = await imageSearch(searchTerm, count, 0)
        if (resultCount === 0) {
          this.setState({ noResults: true })
        }
        this.setState({
          isSearching: false,
          images: searchResults,
          searchTerm,
          offset: nextOffset,
        })
      } catch (error) {
        this.setState({ images: [] })
        this.setState({ isSearching: false })
      }
    }
  }

  async handleLoadMore() {
    const {
      searchTerm, count, offset, images,
    } = this.state
    const { imageSearch } = this.props
    this.setState({ isSearching: true })
    try {
      const { searchResults, nextOffset } = await imageSearch(searchTerm, count, offset)
      this.setState({
        isSearching: false,
        images: [...images, ...searchResults],
        offset: nextOffset,
      })
    } catch (error) {
      this.setState({ isSearching: false })
    }
    analytics.track('Image search load more', {
      searchTerm,
    })
  }

  handleSelectImage(imageIndex) {
    if (!this.state.submitLoading) {
      this.setState({ submitLoading: true })
      const img = this.state.images[imageIndex]
      const thumbnail = {
        src: img.thumbnail,
        w: img.thumbnailWidth,
        h: img.thumbnailHeight,
      }
      const { src } = img
      const { title } = img
      const { attribution } = img
      const file = null
      const isCopyPaste = false
      const isSearchBarPaste = false
      const isImageSearch = true

      this.props.closeInsertImageModal()
      const {
        insertPos, isQuestion, questionPos, questionNode,
      } = this.props
      if (isQuestion) {
        this.props.addQuestionImage(src, thumbnail, title, attribution, insertPos, questionPos, questionNode, file, isImageSearch, isCopyPaste, isSearchBarPaste)
      } else {
        this.props.addChoiceImage(src, thumbnail, title, attribution, insertPos, file, isImageSearch, isCopyPaste, isSearchBarPaste)
      }
    }
  }

  handleSelectFile(e) {
    const fileList = e.target.files
    const file = fileList[0]
    if (file.size > MAX_FILE_SIZE) {
      // this.props.closeInsertImageModal()
      this.props.showNotification('The maximum file size you can upload is 20mb.', 'Sadly your image file is too large. ', 'destroy')
    } else {
      setTimeout(() => { // Start the timer
        this.props.closeInsertImageModal()
      }, 200)

      const src = null
      const thumbnail = null
      const {
        insertPos, isQuestion, questionPos, questionNode,
      } = this.props
      let fileName = file.name
      const extensions = ['.png', '.jpg', '.jpeg', '.tif', '.tiff', '.webp', '.gif']
      extensions.forEach((extension) => {
        fileName = fileName.replace(extension, '')
      })

      const title = fileName
      const attribution = ''
      // const isUpload=true
      if (isQuestion) {
        this.props.addQuestionImage(src, thumbnail, title, attribution, insertPos, questionPos, questionNode, file)
      } else {
        this.props.addChoiceImage(src, thumbnail, title, attribution, insertPos, file)
      }
    }
  }

  render() {
    return (
      <div className='editor-insertImageModalContainer'>
        <EditorInsertImageModal
          noResults={this.state.noResults}
          isSearching={this.state.isSearching}
          handleNewImageSearch={this.handleNewImageSearch}
          loadMore={this.handleLoadMore}
          searchTerm={this.state.searchTerm}
          onSelectImage={this.handleSelectImage}
          images={this.state.images}
          handleSelectFile={this.handleSelectFile}
          handleImageSearchBarPaste={this.handleImageSearchBarPaste}
          closeInsertImageModal={this.props.closeInsertImageModal}
          clearSearch={this.clearSearch}
        />
        <div onClick={this.props.closeInsertImageModal} className='editor-insertImageModalContainerBG' />
      </div>
    )
  }
}

function mapStateToProps() {
  return {
  }
}

export default connect(
  mapStateToProps,
  {
    addQuestionImage,
    addChoiceImage,
    imageSearch,
    showNotification,
    // uploadNewImageToCloudinary
  },
)(EditorInsertImageModalContainer)
